import script from "./VSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./VSelect.vue?vue&type=script&lang=ts&setup=true"

import "./VSelect.vue?vue&type=style&index=0&id=457bb754&lang=sass"

const __exports__ = script;

export default __exports__